'use client';

import cx from 'classnames';
import { useAtomValue } from 'jotai';

import ContentfulRichText from '@flipster/features/src/shared/contentful-rich-text';

import ShareTermButton from '../ShareTermButton';
import { glossaryTermAtom } from '../jotai';
import styles from './index.module.scss';

const GlossaryTermArticle = ({ className }: { className?: string }) => {
  const glossaryTerm = useAtomValue(glossaryTermAtom);
  if (!glossaryTerm) return null;

  return (
    <article className={cx(styles.article, className)}>
      <h1 className={styles.name}>
        {glossaryTerm.name}
        <ShareTermButton className={styles.shareButton} glossaryTerm={glossaryTerm} />
      </h1>

      {glossaryTerm.description && (
        <ContentfulRichText richTextDocument={glossaryTerm.description} startHeadingLevel={2} />
      )}
    </article>
  );
};

export default GlossaryTermArticle;
